import vue from 'vue'
import {getUserData} from "@/auth/utils";

const seq = require("seq-logging");
let logger = null
export default () => {
        vue.config.errorHandler = function (error, vm, info) {
            try {
                console.error(error)
                logger = new seq.Logger({
                    serverUrl: "https://seq.simagar.com",
                    apiKey: "3v0TlWuqGYhTCCiVrBPk",
                });
                logger.emit({
                    timestamp: new Date(),
                    level: 'Error',
                    messageTemplate: error && error.message ? error.message : 'Unhandled Exception',
                    properties: {
                        User:getUserData().user?getUserData().user:'',
                        Route: window && window.location && window.location.href ? window.location.href : '',
                        Initiator: info,
                        Navigator: navigator && navigator.userAgent ? navigator.userAgent : '',
                        RootElementClassName: vm.$el && vm.$el.className ? vm.$el.className : ''
                    },
                    exception: error && error.stack ? error.stack : 'Error not found'
                });
            } catch (error) {
                console.error(error)
            } finally {
                logger.close()
            }
        }
};
